import React from 'react';
import { Column, Row, Button, cls } from '../../packages/components';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Assets from '../../requests/apa/Asset';
import PropTypes from 'prop-types';
import Legals from '../../requests/apa/Legals';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import './styles/ModalPoliticaPrivacidad.scss';

const MAIN_CLASSNAME = 'aaf_app_modal-privacy-policies';
const PRIVACY_POLICIES__KEY = 'pp_full_text';



const BodyContent = ({ props }) => {

    const region = DeviceStorage.getItem('region');
    let data = Legals.get(PRIVACY_POLICIES__KEY, region, '');
    data = data.replace(/<a/gi, "<a onClick='return false;'");

    return (
        <div className={MAIN_CLASSNAME}>
            <Row>
            <div className='privacy-policies'>
                    <div className='privacy-policies-text' dangerouslySetInnerHTML={{__html: data}} />
                </div>
                <div className='gradient'>
                </div>
            </Row>
        </div>
    );
};

const ModalPoliticaPrivacidad = (props = {}) => {
    const customizedClassName = `modal-button-return`;
    const {onkeyDown = () =>{}, onkeyUp = () =>{}, callbackWhenBack = ()=>{}} = props;
    const p = {
        alwaysEnabled: true,
        buttonsAlign: 'vertical',
        aafNewStyle: true,
        className: 'aaf-modal',
        showLogo: true,
        yellowAction: (e) => callbackWhenBack(),
        onkeyDown,
        onkeyUp,
        callbackWhenBack,        
        colorButtons: 
            [
                {
                    content: Translator.get('top_head_option_button_back', 'REGRESAR'),
                    props: {
                        color: 'yellow',
                        className: customizedClassName,
                        imgSrc: Assets.get('top_head_option_back', ''),
                        onClick: (e) => callbackWhenBack(),
                    },
                },
              ]
            ,
    };
    return (
        <ModalWrapper {...p}>
            <BodyContent props={props} />
        </ModalWrapper>
    );
};

ModalPoliticaPrivacidad.propTypes = {
    content: PropTypes.string,
    className: PropTypes.string,
};

export default withOnClose(ModalPoliticaPrivacidad);


// WEBPACK FOOTER //
// ./src/components/Modal/ModalPoliticaPrivacidad.jsx